import React, { useEffect, useState } from 'react';
import ComSelectRecipentPopUp from './ComSelectRecipentPopUp';
import AccordianSideBar from './AccordianSideBar';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import SingleMsg from './SingleMsg';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import SingleMsgView from './SingleMsgView';
import ComPatientComposeText from './ComPatientComposeText';
import ComPatientEmailCompose from './ComPatientEmailCompose';
import ComStaffMsgCompose from './ComStaffMsgCompose';
import { useDispatch, useSelector } from 'react-redux';
import {
  setMessageCount,
  setMsgInboxCount,
} from '../../redux/slices/communicationSlice';

function MainCom() {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload } = useSelector((store) => store.app);
  //const [allData, setAllData] = useState(null);
  const [selRecipentPopUp, setSelRecipentPopUp] = useState(false);
  const [selectAcord, setSelectAcord] = useState({
    acord: 'textMsgSec',
    box: 'inbox',
    userType: 'clinic',
  });
  const [filterMsgId, setFilterMsgId] = useState('');
  const [selectedMsgId, setSelectedMsgId] = useState(0);
  const [selectedMsgType, setSelectedMsgType] = useState(0);
  const [deleteMsgFromList, setDeleteMsgFromList] = useState(false);
  const [sucPrams, setSucPrams] = useState([]);
  const [reload, setReload] = useState(false);
  const [singleMsgData, setSingleMsgData] = useState(false);

  const [patTextPopUp, setPatTextPopup] = useState(false);
  const [patEmailPopUp, setPatEmailPopUp] = useState(false);
  const [patSecureEmailPopUp, setPatSecureEmailPopUp] = useState(false);

  const [staffMsgPopUp, setStaffMsgPopUp] = useState(false);
  const [tampletList, setTampletList] = useState([]);
  const [serchEmail, setSerchEmail] = useState('');
  const [msgFilter, setMsgFilter] = useState('0');
  const [selectedIdflag, setSelectedIdflag] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/communication/Communication/messageList',
          {
            box: selectAcord?.box, //Inbox, sent, trash//
            userType: selectAcord?.userType, //Patient, clinic//
            filterMsgId: filterMsgId, // ''=>all, 1->text, 2-Email(thread), 3->patient portal //
            loginUserId: user?.id,
            msgId: '',
            msgType: '',
            actionFrom: '', // 'curtain' only in case of curtain else ''
          }
        );
        if (response?.status === 200) {
          //setAllData(response?.data);
          setTampletList(response?.data?.msgListArr || []);
          // setSingleMsgData(response?.data?.msgDetail);
          if (selectedIdflag) {
            setSelectedMsgId(selectedIdflag);
            // setSelectedIdflag(0);
          } else {
            setSelectedMsgId(
              response?.data?.msgListArr[0]
                ? response?.data?.msgListArr[0].msgId
                : 0
            );
          }

          setSelectedMsgType(
            response?.data?.msgListArr[0]
              ? response?.data?.msgListArr[0].type
              : 0
          );
          setMsgInboxCount({
            clinic: response?.data?.msgDetail?.countCliUnreadMsg || 0,
            patient: response?.data?.msgDetail?.countPatUnreadMsg || 0,
          });
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    })();
  }, [selectAcord, filterMsgId, user?.id, reload, dispatch, selectedIdflag]);

  useEffect(() => {
    (async () => {
      try {
        if (selectedMsgId && selectedMsgType) {
          const response = await post(
            'api/communication/Communication/messageDetail',
            {
              msgId: selectedMsgId, // message Id
              type: selectedMsgType, // Inbox, sent, trash//
              loginUserId: user?.id,
              box: selectAcord?.box,
            }
          );
          if (response?.status === 200) {
            setSingleMsgData(response?.data?.msgDetail);
            dispatch(setMessageCount(response?.data?.totalCnt || 0));
            dispatch(
              setMsgInboxCount({
                clinic: response?.data?.countCliUnreadMsg || 0,
                patient: response?.data?.countPatUnreadMsg || 0,
              })
            );
          }
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    })();
  }, [
    selectedMsgId,
    selectedMsgType,
    dispatch,
    selectAcord?.box,
    user?.id,
    globalReload,
  ]);

  const handleShowSingleMsg = async (id, type) => {
    setSelectedMsgId(id);
    setSelectedMsgType(type);
  };

  const handleDeleteSingleMsg = (msgId, type) => {
    setDeleteMsgFromList(true);
    setSucPrams([msgId, type]);
  };

  const handleDeleteMsgFromList = async (prams) => {
    try {
      setDeleteMsgFromList(false);
      const response = await post(
        'api/communication/Communication/deleteMessage',
        {
          msgId: prams[0], // message Id
          msgType: prams[1], // 1, 2, 3
          fromFolder: selectAcord?.box, // inbox, sent, trash
          loginUserId: user?.id,
        }
      );
      if (response?.status === 200) {
        if (response?.data?.statusCode === '1') {
          setUiMessage('suc', response?.data?.msg);
          setReload(!reload);
        } else {
          setUiMessage('err', response?.data?.msg);
        }
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };
  const handlePopUpClose = () => {
    setSelRecipentPopUp(false);
  };

  useEffect(() => {
    const handleReadUnread = (id) => {
      setTampletList((prevList) => {
        return prevList.map((item) => {
          if (item.msgId === id) {
            return { ...item, unreadCl: '' };
          } else {
            return item;
          }
        });
      });
    };
    handleReadUnread(selectedMsgId);
  }, [selectedMsgId, setTampletList]);

  let filteredData =
    tampletList.length > 0 &&
    tampletList.filter((item) => {
      // Filter unread messages if checkbox is checked and apply search filtering
      if (msgFilter === '1') {
        return (
          item.unreadCl !== '' &&
          (item.subLine.toLowerCase().includes(serchEmail.toLowerCase()) ||
            item.msgLine.toLowerCase().includes(serchEmail.toLowerCase()) ||
            item.showName.toLowerCase().includes(serchEmail.toLowerCase()) ||
            item.toUser.toLowerCase().includes(serchEmail.toLowerCase()) ||
            item.toUserForSearch
              .toLowerCase()
              .includes(serchEmail.toLowerCase()))
        );
      } else if (msgFilter === '2') {
        return (
          item.redFlag === '1' &&
          (item.subLine.toLowerCase().includes(serchEmail.toLowerCase()) ||
            item.msgLine.toLowerCase().includes(serchEmail.toLowerCase()) ||
            item.showName.toLowerCase().includes(serchEmail.toLowerCase()) ||
            item.toUser.toLowerCase().includes(serchEmail.toLowerCase()) ||
            item.toUserForSearch
              .toLowerCase()
              .includes(serchEmail.toLowerCase()))
        );
      } else {
        // Apply search filtering only when checkbox is unchecked
        return (
          item.subLine.toLowerCase().includes(serchEmail.toLowerCase()) ||
          item.msgLine.toLowerCase().includes(serchEmail.toLowerCase()) ||
          item.showName.toLowerCase().includes(serchEmail.toLowerCase()) ||
          item.toUser.toLowerCase().includes(serchEmail.toLowerCase()) ||
          item.toUserForSearch.toLowerCase().includes(serchEmail.toLowerCase())
        );
      }
    });

  const handleFlagChange = async (msgId, type, flag) => {
    try {
      const response = await post(
        'api/communication/Communication/setMarkFlag',
        {
          msgId: msgId,
          type: type, //1->sms, 2->email thread, 3->intra msg
          flag: flag, // 1->mark red flag
          loginUserId: user?.id,
        }
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Flag has been updated successfully.');
        setReload(!reload);
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  return (
    <>
      <div className="comm-centre-main-con grid-sec">
        <div className="comm-centre-hdr qc-mid-bdy-hdr clear-top10">
          <span className="widget-hdr-title clear-top">
            Communication Center:
          </span>
          <span
            className="comps-msg-btn actn-yes"
            onClick={() => setSelRecipentPopUp(true)}
          >
            New Message
          </span>
        </div>
        <div className="comm-centre-bdy flex-sec">
          {/* side bar accordian */}
          <AccordianSideBar
            selectFunction={(item) => {
              setSelectAcord(item);
              setSelectedMsgId(selectedMsgId);
              setSelectedMsgType(selectedMsgType);
              setSelectedIdflag(false);
            }}
            selection={selectAcord}
          />
          {/* end side bar accordian */}
          <div className="comm-centre-right-pane">
            <div className="comm-msglist-fltr flex-sec">
              <div className="comm-msglist-srch flex-sec">
                <span
                  id="unreadCheckBlkId"
                  className="left"
                  style={{
                    paddingTop: '5px',
                    width: '100px',
                    marginRight: '50px',
                  }}
                >
                  <span className="left width100">
                    <select
                      className="comm-filter width100"
                      onChange={(e) => {
                        if (filteredData && filteredData.length > 0) {
                          setSelectedMsgId(filteredData[0]?.msgId);
                        }
                        setMsgFilter(e.target.value);
                      }}
                      value={msgFilter}
                    >
                      <option value={'0'}>All</option>
                      <option value={'1'}>Unread</option>
                      <option value={'2'}>Flagged</option>
                    </select>
                  </span>
                </span>
                <span className="width100 fontsize14">
                  Search:&nbsp;&nbsp;
                  <input
                    type="search"
                    className="msg-search"
                    placeholder="search your message here..."
                    value={serchEmail}
                    onChange={(e) => setSerchEmail(e.target.value)}
                  />
                </span>
              </div>
              <div className="comm-msglist-fltr-type flex-sec">
                <span className="width100">
                  Message Type:&nbsp;&nbsp;
                  <select
                    className="comm-filter"
                    onChange={(e) => setFilterMsgId(e.target.value)}
                    value={filterMsgId || ''}
                  >
                    <option value={''}>All</option>
                    <option value={1}>Text</option>
                    <option value={2}>Message</option>
                    <option value={3}>Secure</option>
                  </select>
                </span>
              </div>
            </div>
            <div className="comm-msglist-con flex-sec">
              <div className="comm-msglist qgrid-sec">
                {/* message list */}
                {(() => {
                  if (filteredData && filteredData.length > 0) {
                    return filteredData.map((item, i) => {
                      return (
                        <SingleMsg
                          key={i}
                          item={item}
                          selectedMsgId={selectedMsgId}
                          handleShowSingleMsg={handleShowSingleMsg}
                          handleDeleteSingleMsg={handleDeleteSingleMsg}
                          handleFlagChange={handleFlagChange}
                        />
                      );
                    });
                  } else {
                    return (
                      <span className="no-appoinmnts-here">No message!</span>
                    );
                  }
                })()}

                {deleteMsgFromList && (
                  <ConfirmDialog
                    title={''}
                    bodytext={`Do you want to delete this message thread?`}
                    closeDialog={() => setDeleteMsgFromList(false)}
                    successDialog={handleDeleteMsgFromList}
                    sucPrams={sucPrams}
                  />
                )}
                {/* end message list */}
              </div>
              <div className="comm-centre-thread-sec">
                <span
                  className={`${
                    filteredData && filteredData.length > 0 ? '' : 'hide'
                  }`}
                >
                  {singleMsgData && (
                    <SingleMsgView
                      key={selectedMsgId}
                      data={singleMsgData}
                      handleReload={() => setReload(!reload)}
                      replymsgFlag={() => setSelectedIdflag(selectedMsgId)}
                    />
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selRecipentPopUp && (
        <ComSelectRecipentPopUp
          close={handlePopUpClose}
          setPatTextPopup={() => setPatTextPopup(true)}
          setPatEmailPopUp={() => setPatEmailPopUp(true)}
          setPatSecureEmailPopUp={() => setPatSecureEmailPopUp(true)}
          setStaffMsgPopUp={() => setStaffMsgPopUp(true)}
        />
      )}
      {patTextPopUp && (
        <ComPatientComposeText
          close={() => setPatTextPopup(false)}
          handleReload={() => setReload(!reload)}
        />
      )}
      {patEmailPopUp && (
        <ComPatientEmailCompose
          close={() => setPatEmailPopUp(false)}
          msgType={'1'}
          handleReload={() => setReload(!reload)}
        />
      )}
      {patSecureEmailPopUp && (
        <ComPatientEmailCompose
          close={() => setPatSecureEmailPopUp(false)}
          msgType={'0'}
          handleReload={() => setReload(!reload)}
        />
      )}

      {staffMsgPopUp && (
        <ComStaffMsgCompose
          close={() => setStaffMsgPopUp(false)}
          handleReload={() => setReload(!reload)}
        />
      )}
    </>
  );
}

export default MainCom;
// Worked on the communication part
